// EDEN · app entry. Resolve the session, then start the router.

import { refreshMe } from "./state";
import { initRouter } from "./router";

async function boot(): Promise<void> {
  await refreshMe();
  initRouter();
}

void boot();
